import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ClientJourneyPage } from "@/components/client-journey/client-journey-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/client-journey",
  component: ClientJourneyPageGuard,
});

function ClientJourneyPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as { role?: string })?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <ClientJourneyPage />;
}
